import Vue from 'vue'
import { DateTime } from 'luxon';

Vue.filter('arrivalTime', function (val) {
    if(typeof val === "undefined" || !val) return "";
    let t = val.split(":"),
        h = t[0].length < 2? "0"+t[0] : t[0],
        m = t[1].length < 2? "0"+t[1] : t[1];
    return h + ":" + m;
});

Vue.filter('formatDate', function (val) {
    if(typeof val === "undefined" || !val) return "";
    let d = DateTime.fromISO(val);
    return d.toISODate();
});